import { configureStore } from "@reduxjs/toolkit";
import authenticationSlice from "./Slice/authenticationSlice/authenticationSlice";
import supplierProfileSlice from "./Slice/supplierProfileSlice/supplierProfileSlice";
import staffListSlice from "./Slice/staffListSlice/staffListSlice";
import newBookingSlice from "./Slice/bookingSlice/newBookingSlice";
import onGoingBookingSlice from "./Slice/bookingSlice/onGoingBookingSlice";
import historyBookingSlice from "./Slice/bookingSlice/historyBookingSlice";
import notificationSlice from "./Slice/notificationSlice/notificationSlice";
import FAQSlice from "./Slice/FAQSlice/FAQSlice";
import manageAvailabilitySlice from "./Slice/manageAvailabilitySlice/manageAvailabilitySlice";
import transactionSlice from "./Slice/transactionSlice/transactionSlice";
import bookingDetailSlice from "./Slice/bookingDetail/bookingDetailSlice";
import dashboardSlice from "./Slice/dashboard/dashboardSlice";
import bookingCalendarSlice from "./Slice/bookingCalendarSlice/bookingCalendarSlice";
import recurringBookingDatesSlice from "./Slice/recurringBookingDatesSlice/recurringBookingDatesSlice";
import myServiceSlice from "./Slice/myServicesSlice/myServiceSlice";
import ratingListSlice from "./Slice/ratingListSlice/ratinglistSlice";
import serviceDetailSlice from "./Slice/serviceDetailSlice/serviceDetailSlice";
import customerListSlice from "./Slice/customerList/customerListSlice";
import customerDetailSlice from "./Slice/customerDetailSlice/customerDetailSlice";
import staffListBasedOnBooking from "./Slice/staffListBasedOnBookingSlice/staffListBasedOnBookingSlice";
import sideBar from "./Slice/sideBar";
import category from "./Slice/category";
import categoryDetail from "./Slice/categoryDetail";
import staffDetails from "./Slice/staffDetails";

const store = configureStore({
  reducer: {
    newBooking: newBookingSlice,
    auth: authenticationSlice,
    supplierProfile: supplierProfileSlice,
    staffList: staffListSlice,
    onGoingBooking: onGoingBookingSlice,
    historyBooking: historyBookingSlice,
    notification: notificationSlice,
    FAQ: FAQSlice,
    manageAvailability: manageAvailabilitySlice,
    transaction: transactionSlice,
    bookingDetail: bookingDetailSlice,
    dashboard: dashboardSlice,
    bookingCalendar: bookingCalendarSlice,
    recurringDates: recurringBookingDatesSlice,
    myServices: myServiceSlice,
    ratingList: ratingListSlice,
    serviceDetail: serviceDetailSlice,
    customerList: customerListSlice,
    customerDetail: customerDetailSlice,
    sideBar,
    category,
    categoryDetail,
    staffListBasedOnBooking,
    staffDetails,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
